// extracted by mini-css-extract-plugin
module.exports = {"footer-social":"social-icons_footer-social__a2isq","social-icons-container":"social-icons_social-icons-container__n9zU6","text-terms":"social-icons_text-terms__F_ikH"};